angular.module('bmsApp.ticket', [
	'ui.router'
])
	.config([
		'$stateProvider', function config($stateProvider) {

			$stateProvider

				.state('main.ticket', {
					abstract: true,
					url: '/ticket'
				})

			;
		}]);
